import { ChatState } from 'features/chat/types';

// resetMessages() clears chats, but processMessage() only rebuilds chats that
// have messages — an open, message-less chat leaves activeView dangling.
export const dropStaleActiveView = (state: ChatState) => {
  const { activeView, chats } = state.privateChat;
  if (activeView.name === 'personal' && !chats[activeView.data.id]) {
    state.privateChat.activeView = { name: 'list', data: {} };
  }
};
